const ageGroupOptions = [
	{ id: '1', description: 'Infant' },
	{ id: '2', description: 'Child' },
	{ id: '3', description: 'Adult' },
	{ id: '4', description: 'Senior' },
]

export default ageGroupOptions
